import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { IMAGE_SIDE_LABELS, RATIO_LABELS, ratiosFor, withStep } from "./layout.js";
import { Segmented } from "./controls.js";
import { HEADING_CLASS } from "./styles.js";
const SIDES = ["full", "left", "right"];
/**
 * The picture's part of a step's layout (D37): where it stands and its format. The order of
 * picture, title and text moves in the preview itself, by the grip of each element (22.10.2026).
 *
 * The formats are the ones the presentation offers: a dialog only the wide ones, because a
 * taller picture pushes the button out of the window. Without `onChange` everything is shown
 * and nothing can be changed.
 */
export function LayoutSettings({ layout, step, presentation, idPrefix, onChange, }) {
    const shape = layout[step];
    const id = (part) => `${idPrefix}-${part}`;
    const change = (next) => {
        onChange?.(next);
    };
    return (_jsxs("fieldset", { className: "mt-8 min-w-0", disabled: onChange === undefined, children: [_jsx("legend", { className: HEADING_CLASS, children: "Aufbau" }), _jsx(Segmented, { name: id("bildlage"), legend: "Lage", options: SIDES, labels: IMAGE_SIDE_LABELS, value: shape.image_side, onChange: (side) => {
                    change(withStep(layout, step, { image_side: side }));
                } }), _jsx(Segmented, { name: id("format"), legend: "Format", options: ratiosFor(presentation), labels: RATIO_LABELS, value: shape.ratio, onChange: (ratio) => {
                    change(withStep(layout, step, { ratio }));
                } })] }));
}
//# sourceMappingURL=LayoutSettings.js.map